import { useReducer } from 'react';
import { getSitemapContent } from 'src/services/getSitemapContent';
import { ReportYears } from 'src/store/baseUrl/baseUrlStore.types';
import sitemapStore, { INITIAL_SITEMAP } from 'src/store/sitemap/sitemapStore';
import {
  SitemapStoreKind,
  SitemapStoreType,
} from 'src/store/sitemap/sitemapStore.types';

export interface SitemapHook {
  state: SitemapStoreType;
  actions: {
    getSitemap: (reportYears: ReportYears, language: string) => void;
  };
}

const useSitemapHook = (): SitemapHook => {
  const [state, dispatch] = useReducer(sitemapStore, INITIAL_SITEMAP);

  const getSitemap: (
    reportYears: ReportYears,
    language: string
  ) => Promise<void> = async (reportYears, language) => {
    const data = await getSitemapContent(language, reportYears);
    dispatch({
      type: SitemapStoreKind.INITIAL,
      payload: data,
    });
  };
  return { state, actions: { getSitemap } };
};

export default useSitemapHook;
